import createWorker from './createWorker';

// REMARK: 该方法内 由于web worker限制，不能引入 其他外部文件
function heartbeat() {
  // 通用接口超时时间
  const COMMON_TIMEOUT = 50 * 1000;
  // 心跳间隔时间
  const HEARTBEAT_WAITING = 3 * 1000;
  // 心跳定时器引用
  let $timer: any = null;

  // 创建XMLHTTPRequest实例
  function createXHRInstance() {
    let xhr = null;
    try {
      xhr = new XMLHttpRequest();
    } catch (e) {
      try {
        xhr = new ActiveXObject('Msxml12.XMLHTTP');
      } catch (e) {
        try {
          xhr = new ActiveXObject('Microsoft.XMLHTTP');
        } catch (e) {
          xhr = null;
          console.warn('an error accured when create XMLHttpRequest instance.');
        }
      }
    }
    return xhr;
  }

  // 定时任务，setTimeout 模拟 setInterval
  function setAccurateIntervalTask(task: any, wait: number, context?: any) {
    const waitTemp = typeof wait === 'number' ? wait : 1000;
    const contextTemp = context;
    const temp = function () {
      task.call(contextTemp);
      $timer = setTimeout(temp, waitTemp);
    };
    $timer = setTimeout(temp, waitTemp);
  }

  // 关闭定时任务
  function clearAccurateIntervalTask() {
    if ($timer) {
      clearTimeout($timer);
      $timer = null;
    }
  }

  // 获取格式化时间
  function getFormattedTime(dateObj?: Date) {
    const dateObjTemp = dateObj || new Date();
    const year = dateObjTemp.getFullYear();
    let month: number | string = dateObjTemp.getMonth() + 1;
    let date: number | string = dateObjTemp.getDate();
    let hours: number | string = dateObjTemp.getHours();
    let minutes: number | string = dateObjTemp.getMinutes();
    let seconds: number | string = dateObjTemp.getSeconds();
    let milliseconds: number | string = dateObjTemp.getMilliseconds();
    let dateStr = '';
    let timeStr = '';

    month = String(month).padStart(2, '0');
    date = String(date).padStart(2, '0');
    hours = String(hours).padStart(2, '0');
    minutes = String(minutes).padStart(2, '0');
    seconds = String(seconds).padStart(2, '0');
    milliseconds = String(milliseconds).padStart(2, '0');
    dateStr = [year, month, date].join('-');
    timeStr = [hours, minutes, seconds].join(':');

    return `${dateStr} ${timeStr} ${milliseconds}`;
  }

  function getXHRError(xhr: XMLHttpRequest): Error {
    let errMsg = '';
    try {
      const res = JSON.parse(xhr?.response);
      errMsg = res?.msg;
    } catch (exception) {
      errMsg = '';
    }
    errMsg = errMsg || xhr?.statusText || 'unknow error.';
    return new Error(errMsg);
  }

  // 获取下载元数据，包含预估时间，文件名， 队列信息等
  function getDownloadMetadata(
    data: {
      origin: string;
      authorization: string;
      taskId: string;
      baseSystematicName?: 'intelligence_pc' | 'dashboard' | 'datalab' | 'undefined';
      dashboardId?: string;
    },
    successCallback: (res: any) => void,
  ) {
    const xhr = createXHRInstance();
    const sendReqTime = getFormattedTime();
    const params = {
      task_id: data.taskId || '',
      request_id: sendReqTime,
      dashboard_id: data?.dashboardId,
    };
    const serializedParams = JSON.stringify(params);
    // 获取下载预估时间、下载文件名接口
    const CALCULATE_DOWNLOAD_INFO_URL = `api/v1/${
      data?.baseSystematicName === 'undefined' ? 'intelligence_pc' : data?.baseSystematicName
    }/downloadTaskHeart`;
    const url = origin?.endsWith('/')
      ? origin + CALCULATE_DOWNLOAD_INFO_URL
      : `${origin}/${CALCULATE_DOWNLOAD_INFO_URL}`;
    xhr.open('POST', url, true);
    xhr.timeout = COMMON_TIMEOUT;
    xhr.responseType = 'text';
    xhr.setRequestHeader('authorization', data.authorization);
    xhr.setRequestHeader('content-type', 'application/json; charset=utf-8');
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          successCallback(xhr.response);
        } else {
          this.onerror(getXHRError(xhr));
        }
      }
    };
    xhr.onerror = function (error: Error) {
      throw error;
    };
    xhr.send(serializedParams);
  }

  onmessage = function (e) {
    const data = e.data || {};
    const { type } = data;

    if (type === 'start') {
      // 启用心跳定时器
      const params = data.params || {};
      const origin = params ? params.origin : '';
      const authorization = params ? params.authorization : '';
      const dashboardId = params ? params.dashboardId : '';
      const taskId = params ? params.taskId : '';
      const baseSystematicName = params ? params.baseSystematicName : '';
      setAccurateIntervalTask(() => {
        getDownloadMetadata(
          {
            origin,
            taskId,
            baseSystematicName,
            authorization,
            dashboardId,
          },
          (res) => {
            postMessage(res);
          },
        );
      }, HEARTBEAT_WAITING);
    } else if (type === 'stop') {
      // 停止心跳定时器
      clearAccurateIntervalTask();
    }
  };
}

export default function createHeartbeatWorker(): Worker {
  return createWorker(heartbeat);
}
